import { format, getQuarter } from 'date-fns';
import { CircularProgress } from 'material-ui';
import queryString from 'query-string';
import * as React from 'react';
import { withRouter } from 'react-router';
import { setLoading, setSuccess } from '../../actions/loadingActions';
import { IHistory } from '../../interfaces';
import { PlantModel } from '../../model/PlantModel';
import { SettledFormModel } from '../../model/SettledFormModel';
import { getSettledForms, getPlantDetails } from '../../services/plantService';
import '../Reports/reports.scss';
import { Async } from '../reusableComponents/Async';
import { ModalError } from '../reusableComponents/ModalError';
import { ModalLoader } from '../reusableComponents/ModalLoader';
import { FooterCard } from './FooterCard';

export interface IListFooterProps {
    instances: PlantModel[];
    index: number;
    id: string;
    onClose: Function;
    history: IHistory;
    location: {
        search: string;
    };
}

export interface IListFooterState {
    date: Date;
    selectedDate: string;
    selectedQuarter: string;
    selectedYear: string;
    selectedOutfall: string;
    selectedRegion: string;
    outFall: string;
    showQuarterSelection: boolean;
    showOutFallSelection: boolean;
}

export class ListFooterImpl extends React.Component<IListFooterProps, IListFooterState> {

    constructor(props) {
        super(props);
        let date = new Date();
        let quarter = getQuarter(date).toString().length > 1 ?
            getQuarter(date).toString() : `0${getQuarter(date).toString()}`;
        if (this.props.location.search) {
            const { search } = this.props.location;
            date = new Date(queryString.parse(search).date);
            quarter = queryString.parse(search).quarter ? queryString.parse(search).quarter : quarter;
        }
        this.state = {
            showQuarterSelection: false, date, selectedDate: format(new Date(), 'DD-MM-YYYY'),
            selectedQuarter: '', selectedYear: '', selectedRegion: 'All', selectedOutfall: '',
            showOutFallSelection: false, outFall: ''
        };
    }
    promise = async () => {
        if (!this.props.id) {
            return true;
        }
        
        const instances = PlantModel.get(this.props.id); 
        await getPlantDetails(instances.props.PlantId);
        await getSettledForms(format(this.state.date, 'MMDDYYYY'), this.props.id);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.index !== nextProps.index) {
            this.setState({
                showQuarterSelection: false, date: new Date(), selectedDate: format(new Date(), 'DD-MM-YYYY'),
                selectedQuarter: '', selectedYear: '', selectedRegion: 'All', selectedOutfall: ''
            });
        }
    }

    identifier = 'InspectionFooter';

    static defaultProps: IListFooterProps;

    renderCards = () => {
        const { history: { push } } = this.props;
        const settledFormInstance = SettledFormModel.get(this.props.id);
        const instances = PlantModel.get(this.props.id);
        if (!instances || !settledFormInstance) {
            return <div style={{
                minHeight: '25vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }} >
                <CircularProgress size={150} color="#A4BF43" thickness={5} />
            </div>;
        }
        const {  id: PlantId } = instances.props;
        const { DailyForm, MonthlySW, MonthlySpillLogs, MonthlyUSTRect, PlantPreventive,
            MonthlyUSTSpill, QTRVisual, ShopInspection, MonthlySPCC, InCompleteOutfalls } = settledFormInstance.props;
        return <div className="list-footer-container" style={{ display: 'flex' }} >
            <div className="main-container" >
                <div className="title" >
                    <span> Daily Forms </span>
                </div>
                <div className="card-container" >
                    <FooterCard
                        id="DailyForm"
                        redirectTo="/DailyForm"
                        isClickable={DailyForm}
                        plantUID={PlantId}
                        label={<span>Daily <br /> Form</span>}
                        date={this.state.date}
                        // history={this.props.history}
                    />
                    <FooterCard
                        id="DailyForm"
                        redirectTo="/PlantPreventive"
                        isClickable={PlantPreventive}
                        plantUID={PlantId}
                        label={<span>Preventive <br /> Maintenance</span>}
                        date={this.state.date}
                    />
                </div>
            </div>
            <div className="main-container" >
                <div className="title" >
                    <span> Monthly Forms </span>
                </div>
                <div className="card-container">
                    <FooterCard
                        id="Monthly"
                        redirectTo="/monthly-checklist-form/MonthlySW"
                        isClickable={MonthlySW}
                        plantUID={PlantId}
                        label={<span>Monthly <br /> SW</span>}
                        date={this.state.date}
                    />
                    <FooterCard
                        id="Monthly"
                        redirectTo="/monthly-checklist-form/MonthlySPCC"
                        isClickable={MonthlySPCC}
                        plantUID={PlantId}
                        label={<span>Monthly <br /> SPCC</span>}
                        date={this.state.date}
                    />
                    <FooterCard
                        id="Monthly"
                        redirectTo="/monthly-checklist-form/MonthlyUSTSpill"
                        isClickable={MonthlyUSTSpill}
                        plantUID={PlantId}
                        popOverMessage="Fill FollowUp"
                        label={<span>UST Spill <br /> Container</span>}
                        date={this.state.date}
                    />
                    <FooterCard
                        id="Monthly"
                        redirectTo="/monthly-checklist-form/MonthlyUSTRect"
                        isClickable={MonthlyUSTRect}
                        plantUID={PlantId}
                        label={<span>UST <br />  Rectifier</span>}
                        date={this.state.date}
                    />
                    <FooterCard
                        id="Monthly"
                        redirectTo="/monthly-checklist-form/MonthlySpillLogs"
                        isClickable={MonthlySpillLogs}
                        plantUID={PlantId}
                        label={<span>Spills &amp; <br />Leaks</span>}
                        date={this.state.date}
                    />
                </div>
            </div>
            <div className="main-container"  >
                <div className="title" >
                    <span> Quarterly Forms </span>
                </div>
                <div className="card-container">
                    <FooterCard
                        id="QTRVisual"
                        redirectTo="/quarterly-checklist-form/QTRVisual"
                        isClickable={QTRVisual}
                        plantUID={PlantId}
                        label={<span>Visual <br /> Reports</span>}
                        date={this.state.date}
                        InCompleteOutfalls={InCompleteOutfalls}
                        outfall={this.state.outFall}
                    />
                    <FooterCard
                        id="ShopInspection"
                        redirectTo="/quarterly-checklist-form/ShopInspection"
                        isClickable={ShopInspection}
                        plantUID={PlantId}
                        label={<span>Shop <br /> Inspection</span>}
                        date={this.state.date}
                    />
                </div>
            </div>
        </div >;
    }

    renderContent = () => {
        const instances = PlantModel.get(this.props.id);
        const { date, selectedDate } = this.state;
        if (!instances) {
            return <span />;
        }
        return (
            <div className="list-footer-monthly" >
                <Async
                    identifier={this.identifier}
                    promise={this.promise}
                    loader={<ModalLoader />}
                    content={this.renderCards()}
                    error={<ModalError />}
                />
            </div>);
    }

    render() {
        return this.renderContent();
    }
}

export const ListFooter = withRouter(ListFooterImpl);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Inspections/ListFooter.tsx